import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getWorkOrdersProducts(companyId, workOrderId) {
	return dataTransferWrap(
		ModulesMap.WORK_ORDERS_PRODUCTS,dtConfig[ModulesMap.WORK_ORDERS_PRODUCTS].getWorkOrdersProducts,
		{
			urlParams: {
				companyId: companyId,
                workOrderId: workOrderId,
			},
		}
	)
}

function getWorkOrdersProduct(companyId, workOrderId, productId) {
	return dataTransferWrap(
		ModulesMap.WORK_ORDERS_PRODUCTS,dtConfig[ModulesMap.WORK_ORDERS_PRODUCTS].getWorkOrdersProduct,
		{
			urlParams: {
				companyId: companyId,
				workOrderId: workOrderId,
                productId: productId,
			},
		}
	)
}

function createWorkOrdersProduct(companyId, workOrderId, payload) {
	return dataTransferWrap(
		ModulesMap.WORK_ORDERS_PRODUCTS,dtConfig[ModulesMap.WORK_ORDERS_PRODUCTS].createWorkOrdersProduct,
		{
			urlParams: {
				companyId: companyId,
                workOrderId: workOrderId,
			},
			...payload,
		}
	)
}

function putWorkOrdersProduct(companyId, workOrderId, productId, payload) {
	return dataTransferWrap(
		ModulesMap.WORK_ORDERS_PRODUCTS,dtConfig[ModulesMap.WORK_ORDERS_PRODUCTS].putWorkOrdersProduct,
		{
			urlParams: {
				companyId: companyId,
				workOrderId: workOrderId,
                productId: productId,
			},
			...payload,
		}
	)
}

function patchWorkOrdersProduct(companyId, workOrderId, productId, payload) {
	return dataTransferWrap(
		ModulesMap.WORK_ORDERS_PRODUCTS,dtConfig[ModulesMap.WORK_ORDERS_PRODUCTS].patchWorkOrdersProduct,
		{
			urlParams: {
				companyId: companyId,
				workOrderId: workOrderId,
                productId: productId,
			},
			...payload,
		}
	)
}

function deleteWorkOrdersProduct(companyId, workOrderId, productId) {
	return dataTransferWrap(
		ModulesMap.WORK_ORDERS_PRODUCTS,dtConfig[ModulesMap.WORK_ORDERS_PRODUCTS].deleteWorkOrdersProduct,
		{
			urlParams: {
				companyId: companyId,
				workOrderId: workOrderId,
                productId: productId,
			},
		}
	)
}

export default {
	getWorkOrdersProducts,
    getWorkOrdersProduct,
    createWorkOrdersProduct,
    putWorkOrdersProduct,
    patchWorkOrdersProduct,
    deleteWorkOrdersProduct,
}

